import { useState } from "react";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200/80 rounded-lg border border-background-200/80 bg-background-100">
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={f.q} className="px-4 md:px-6">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 py-4 text-left"
            >
              <span className="font-heading text-base font-bold text-foreground-900">
                {f.q}
              </span>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-foreground-600 transition-transform duration-300 ${
                  isOpen ? "rotate-180" : ""
                }`}
              >
                <i className="ri-arrow-down-s-line text-lg"></i>
              </span>
            </button>
            <div
              className={`grid transition-all duration-300 ${
                isOpen ? "grid-rows-[1fr] pb-5 opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="text-sm leading-7 text-foreground-600">{f.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}